"use client"

import { ThemeType } from "@/context/ThemeContext"
import { useEffect, useState } from "react"
import { motion } from "framer-motion"
import styles from "./Navbar.module.css"
import { NavbarLogo } from "./NavbarLogo"
import { NavbarMenu } from "./NavbarMenu"

// Create motion components
const MotionHeader = motion.create("header")

export interface NavbarProps {
  themeSetting: ThemeType
  toggleTheme: () => void
}

export const Navbar = (props: NavbarProps) => {
  const [isScrolled, setIsScrolled] = useState(false)

  // Add scroll detection
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }

    window.addEventListener("scroll", handleScroll)
    // Initialize scroll state
    handleScroll()

    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <MotionHeader
      className={`nav-style fixed top-0 z-50 w-full backdrop-blur-md transition-all duration-300 ease-in-out ${
        isScrolled ? "shadow-md shadow-foreground-subtle/10" : ""
      } ${styles.navbarWrapper}`}
    >
      <div className="mx-auto flex max-w-screen-2xl items-center justify-between px-6 py-2.5">
        <NavbarLogo />
        <NavbarMenu {...props} />
      </div>
    </MotionHeader>
  )
}
